import React, { useState } from 'react';
import { IMarketplaceTilesLocationValue } from 'src/typings/marketplace';
import { readURL } from 'src/helpers';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import { translations } from 'src/constants/translations';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import {
  useStyles,
} from './styles';

interface IProps {
  item: IMarketplaceTilesLocationValue;
  lang: string;
  onChange: (item: IMarketplaceTilesLocationValue) => void,
}
export const TileLocationCity: React.FC<IProps> = ({ item, lang, onChange }) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [image, setImage] = useState<string | null>(item.iconFileUri?.fileUrl || null);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  return (
    <SubGroupWrapper
      name={item.property?.translates?.[lang] || item.property?.systemName || ''}
      customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
      rocketState={rocketState}
      onRocket={rocketChange}
    >
      <div className={styles.tileLocationCityWrapper}>
        <UploadMarketplace
          register={() => {}}
          registerName=""
          image={image}
          onUpload={async (file, response) => {
            onChange({ ...item, iconFileUri: response.data[0] });
            const base64: string = await readURL(file);
            if (base64) {
              setImage(base64);
            }
          }}
        />
        <BoxFormTextField
          label={translations.prefix}
          name="prefix"
          defaultValue={item.prefix?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(item, 'prefix', lang, event.target.value));
          }}
        />
        <BoxFormTextField
          label={translations.suffix}
          name="prefix"
          defaultValue={item.suffix?.[lang]}
          onChange={(event) => {
            onChange(updateTranslatedField(item, 'suffix', lang, event.target.value));
          }}
        />
      </div>
    </SubGroupWrapper>
  );
};
